import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import { instance } from "src/services/api-client";
import { IUser } from "src/@types/users";
import { ISettignsValues } from "src/page-components/cabinet/settings/types";
import { NotificationService } from "src/helpers/notifications";
import {
  errorResponsesTrns,
  pendingResponsesTrns,
  successfulResponsesTrns,
} from "src/translate/responses";
import Cookies from "js-cookie";
import { REFRESH_TOKEN } from "src/constants/cookiesKeys";
import { isTokenExpired } from "src/services/interceptors";

export const CURRENT_USER_SLICE_NAME = "currentUser";

export const getCurrentUserAsync = createAsyncThunk(
  `${CURRENT_USER_SLICE_NAME}/fetchCurrentUser`,
  async (_, { rejectWithValue }) => {
    try {
      const refreshToken = Cookies.get(REFRESH_TOKEN);
      const isRefreshTokenExpired = isTokenExpired(refreshToken);

      if (isRefreshTokenExpired) return null;

      const { data } = await instance.get<IUser>("/user/current/");

      return data;
    } catch ({ response }) {
      const errorText = response?.data?.error;
      return rejectWithValue(errorText);
    }
  }
);

interface IUpdateCurrentUserParams {
  values: ISettignsValues;
  onSuccess?: VoidFunction;
}
export const updateCurrentUserAsync = createAsyncThunk(
  `${CURRENT_USER_SLICE_NAME}/updateCurrentUser`,
  async (
    { values, onSuccess = () => {} }: IUpdateCurrentUserParams,
    { rejectWithValue }
  ) => {
    const toastId = NotificationService.loading(
      pendingResponsesTrns.updateUser
    );

    try {
      const { password, first_name, last_name, phone_number, ...profileInfo } =
        values;

      const { data } = await instance.patch<IUser>("/user/profile_update/", {
        password: password || undefined,
        first_name,
        last_name,
        phone_number,
        profile: { ...profileInfo },
      });
      NotificationService.updateToSuccess(
        toastId,
        successfulResponsesTrns.updateUser
      );
      onSuccess();
      return data;
    } catch ({ response }) {
      const errorText = response?.data?.error || errorResponsesTrns.updateUser;

      NotificationService.updateToError(toastId, errorText);

      return rejectWithValue(errorText);
    }
  }
);

export const clearCurrentUser = createAction(
  `${CURRENT_USER_SLICE_NAME}/clearCurrentUser`
);
